import { render, staticRenderFns } from "./ConfigLoadedView.vue?vue&type=template&id=fb07f6ca&lang=pug&"
import script from "./ConfigLoadedView.vue?vue&type=script&lang=ts&"
export * from "./ConfigLoadedView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports